import FansiLogoImage from '@/assets/icons/purged/logo.svg'
import FansiClassImage from '@/assets/svg/default/for-creators/fansi-class.svg'
import FansiCollectionsImage from '@/assets/svg/default/for-creators/fansi-collections.svg'
import FansiDigitalImage from '@/assets/svg/default/for-creators/fansi-digital.svg'
import FansiExperienceImage from '@/assets/svg/default/for-creators/fansi-experience.svg'
import FansiVideoImage from '@/assets/svg/default/for-creators/fansi-video.svg'

export const FOR_CREATORS_SECTIONS = [
  {
    title: 'fansi_products',
    text: 'fansi_products_desc',
    image: <FansiDigitalImage />,
  },
  {
    logo: <FansiLogoImage />,
    title: 'fansi_collections',
    text: 'fansi_collections_desc',
    image: <FansiCollectionsImage />,
  },
  {
    logo: <FansiLogoImage />,
    title: 'fansi_class',
    text: 'fansi_class_desc',
    image: <FansiClassImage />,
  },
  {
    logo: <FansiLogoImage />,
    title: 'fansi_video',
    text: 'fansi_video_desc',
    image: <FansiVideoImage />,
  },
  {
    logo: <FansiLogoImage />,
    title: 'fansi_experience',
    text: 'fansi_experience_desc',
    image: <FansiExperienceImage />,
  },
]
